export enum EMappingRuleType {
  NORMAL,
  PREDEFINE,
}

export enum ERuleActionType {
  DELETE_ALL,
  DELETE_RULE_GROUP,
  DELETE_RULE_ITEM,
  ADD_RULE_GROUP,
  ADD_AND_RULE_ITEM,
  ADD_OR_RULE_ITEM,
  LOGIC_OPERATOR_CHANGE,
  ADD_METADATA_GROUP,
  ADD_OR_METADATA_ITEM,
  DELETE_METADATA_GROUP,
  DELETE_METADATA_ITEM,
}
